import OldOrderManage from '@/pages/oldPlatform/oldOrderManage'

export default [
  {
    path: '/oldOrderManage',
    name: 'OldOrderManage',
    component: OldOrderManage,
    meta: { name: '工单管理', keepAlive: true }
  }
]



// WEBPACK FOOTER //
// ./src/router/oldPlatform/oldOrderManage.js